import * as Model from "@effect/sql/Model";
import { Schema } from "effect";

/**
 * Incident status.
 * @since 1.0.0
 */
export const IncidentStatus = Schema.Literal("open", "resolved");
export type IncidentStatus = Schema.Schema.Type<typeof IncidentStatus>;

/**
 * Incident severity level.
 * @since 1.0.0
 */
export const IncidentSeverity = Schema.Literal("low", "medium", "high", "critical");
export type IncidentSeverity = Schema.Schema.Type<typeof IncidentSeverity>;

/**
 * A single timeline entry for an incident.
 * @since 1.0.0
 */
export const TimelineEntry = Schema.Struct({
  timestamp: Schema.String,
  type: Schema.String,
  body: Schema.String,
  authorId: Schema.String,
});
export type TimelineEntry = Schema.Schema.Type<typeof TimelineEntry>;

/**
 * Incident model for structured incident tracking.
 *
 * @since 1.0.0
 */
export class Incident extends Model.Class<Incident>("Incident")({
  id: Model.Generated(Schema.String),
  nodeId: Schema.String,
  customerId: Schema.String,
  title: Schema.String,
  status: Schema.optionalWith(IncidentStatus, { default: () => "open" as const }),
  severity: IncidentSeverity,
  timeline: Schema.Array(TimelineEntry),
  createdAt: Model.DateTimeInsertFromDate,
  resolvedAt: Schema.NullOr(Schema.DateTimeUtc),
}) {}
